var ShopProfile = (function () {
    var url = "https://www.erotikastore.eu";
    //----> GET
    var getURLProfile = function () {
        return url;
    };
    return {
        getURL: getURLProfile,
    }
})();
export default ShopProfile;